import { useEffect, useState } from "react";

/**
 * Frame-rate readout, replacing the hand-rolled `Stats` DOM widget that used to
 * be appended into the node canvas.
 */
export function FpsMeter({ className = "" }: { className?: string }) {
  const [fps, setFps] = useState(0);

  useEffect(() => {
    let frame = 0;
    let frames = 0;
    let since = performance.now();

    const tick = (): void => {
      frame = requestAnimationFrame(tick);
      frames += 1;

      const now = performance.now();
      if (now - since < 500) return;

      setFps(Math.round((frames * 1000) / (now - since)));
      frames = 0;
      since = now;
    };

    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <span
      className={`rounded bg-black/50 px-1.5 py-0.5 font-mono text-[10px] text-teal-300 tabular-nums ${className}`}
    >
      {fps} FPS
    </span>
  );
}
